import { LoginForm } from "@thecb/components";
import * as Nested from "@/util/Nested";
import * as AlertBarState from "@/components/alert-bar/AlertBar.state";
import { getSessionExists, setSessionExists } from "@/state/okta/okta.state";
import {
  requestCurrentUser,
  setOktaCredentialsProvider,
} from "@/components/currentUser/CurrentUser.state";

export const LOGIN_ERROR = "login/LOGIN_ERROR";
export const loginError = (error) => ({ type: LOGIN_ERROR, payload: { error } });

export const LOGOUT_FROM_INACTIVITY = "login/LOGOUT_FROM_INACTIVITY";
export const logoutFromInactivity = () => ({
  type: LOGOUT_FROM_INACTIVITY,
});

const initialState = {
  submitting: false,
  error: false,
};

export const _reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case LOGIN_ERROR:
      return {
        ...state,
        submitting: false,
        error: payload,
      };
    default:
      return state;
  }
};

export const _mapStateToProps = (state) => ({
  ...state.login,
  oktaSessionExists: getSessionExists(state),
  oidc: state.config.oidc,
});

export const _mapDispatchToProps = (dispatch) => ({
  requestCurrentUser: (payload) => dispatch(requestCurrentUser(payload)),
  setSessionExists: (value) => dispatch(setSessionExists(value)),
  setOktaCredentialsProvider: (credentialsProvider) =>
    dispatch(setOktaCredentialsProvider(credentialsProvider)),
  logoutFromInactivity: () => dispatch(logoutFromInactivity()),
});

export const ALERT_BAR_ACTION = "login/ALERT_BAR_ACTION";
export const loginAlertBarAction = Nested.nestedAction(ALERT_BAR_ACTION);

export const LOGIN_FORM_ACTION = "login/LOGIN_FORM_ACTION";
export const loginFormAction = Nested.nestedAction(LOGIN_FORM_ACTION);

const {
  reducer: nestedReducer,
  mapStateToProps,
  mapDispatchToProps,
  actions,
} = Nested.nestStates(
  {
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps,
  },
  {
    forms: {
      loginForm: {
        ...LoginForm,
        actionType: LOGIN_FORM_ACTION,
      },
    },
    alertBars: {
      loginAlertBar: {
        ...AlertBarState,
        actionType: ALERT_BAR_ACTION,
      },
    },
  },
  "login"
);

const reducer = (state, action) => nestedReducer(state, action);

export { reducer, mapStateToProps, mapDispatchToProps, actions };
